var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export var populateInsiderObjectUser = function (user) {
    if (typeof window !== "undefined" && window.insider_object) {
        window.insider_object.user = __assign(__assign({ language: "pt-BR" }, window.insider_object.user), user);
    }
    return;
};
